import stringify from 'json-stable-stringify';
import moize from 'moize';

import appSettings from 'wanderu-config';

function defaultSerialize(...args) {
    return stringify(args);
}

function memoize(fn, opts = {}) {
    const {
        deep = false,
        limit = 10000,
        serializer,
    } = opts;

    if (typeof limit !== 'number') {
        throw new Error('memoize limit must be a number');
    }

    const memoizedFn = moize(fn, {
        isDeepEqual: deep,
        maxSize: limit,
        isSerialized: !!serializer,
        serializer: (args) => serializer(...args),
    });

    memoizedFn.getItem = (...args) => {
        return memoizedFn.get(args);
    };

    return memoizedFn;
}

function memoizeOnClient(fn, opts) {
    return appSettings.env.isClient
        ? memoize(fn, opts)
        : fn;
}

export {
    defaultSerialize,
    memoize,
    memoizeOnClient,
};
